import { defineStore } from 'pinia';
import { Component, ref } from 'vue';

export interface NavItem {
  title: string;
  icon: Component;
  routeName: string;
}

export const useAdminNavStore = defineStore('adminNav', () => {
  const navItems = ref<NavItem[]>([]);

  return {
    navItems,
  };
});
